const initialState = () => ({
  order: {},
  hardwareTax: {},
  subscriptionTax: {},
  termsAccepted: false,
  pdfFile: '',

  cardToken: '',
  source: '',
  paymentMethodId: '',
  paymentMethod: '',
  invoicePaymentMethod: null,
  selectedPaymentMethod: {},
  paymentMethods: [],
  setupIntent: {},
  paymentPending: false,
  partnerSettings: {},
  actionModalView: '',
  showActionModal: false,
  loading: true,
  loadingOrder: true,
  loadingPaymentMethod: true,
  loadingAllPaymentMethods: true,
  calculatingTax: true,
  processingOrder: false,
  processingDirectDebit: false,
});

export default initialState;
